export default "<div [innerHtml]=\"translateText | safeHtml\"></div>\n"